import { Box, Button, Typography } from "@mui/material";
import React, { useState } from "react";
import { FeedbackDialog, FeedbackItem } from "./FeedbackDialog";
import { Email } from "../../models/Email";
import { SendEmail } from "../../apis/SendEmail";
import { SUPPORT_EMAIL } from "../../constants";

interface Props {
  dialogTitle?: string;
  questionText?: string;
  buttonText?: string;
  screenName?: string;
}

export const FeedbackCheck = ({
  // onSubmit,
  dialogTitle = "Let us know how we can help",
  questionText = "Can’t find something or experiencing a problem on this page?",
  buttonText = "Let us know",
  screenName,
}: Props): JSX.Element => {
  const [feedbackOpen, setFeedbackOpen] = useState(false);

  const handleFeedback = async (feedback: FeedbackItem): Promise<boolean> => {
    await SendEmail.send(
      new Email(
        SUPPORT_EMAIL,
        feedback.feedback,
        feedback.feedbackTypeOther || feedback.feedbackType,
        feedback.screenName,
        Email.getDeviceDetails()
      )
    );
    return true;
  };

  return (
    <Box
      sx={{
        textAlign: "center",
      }}
    >
      <Typography variant="body2">{questionText}</Typography>
      <Button onClick={() => setFeedbackOpen(true)}>
        <Typography variant="body2" color="secondary">
          {buttonText}
        </Typography>
      </Button>
      <FeedbackDialog
        title={dialogTitle}
        open={feedbackOpen}
        onSubmit={handleFeedback}
        screenName={screenName}
        onCancel={() => setFeedbackOpen(false)}
      />
    </Box>
  );
};
